module.exports = __webpack_public_path__ + "static/dribbble-1e36204e5eb98b62274fd454831c7108.mp4";